import { render, staticRenderFns } from "./LayoutControl.vue?vue&type=template&id=13ea760e&scoped=true"
import script from "./LayoutControl.vue?vue&type=script&setup=true&lang=ts"
export * from "./LayoutControl.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./LayoutControl.vue?vue&type=style&index=0&id=13ea760e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ea760e",
  null
  
)

export default component.exports